import { createLazyFileRoute } from "@tanstack/react-router";

import { AuditLog } from "@/features/admin/routes/AuditLog";

export const Route = createLazyFileRoute("/_auth/admin/audit/")({
  component: AuditLog,
});
